import { BasicService } from './core/basic.service'

export class BrandService extends BasicService {

  static brandList() {
    return this.http.get('/Goods/brandList');
  }

  static brandSelect() {
    return this.http.get('/Goods/brandList').then(data => {
      data.forEach(item => {
        item.label = item.brand_name;
        item.value = item.id;
      });
      return data;
    });
  }

  static async save(data) {
    if (data.images[0].name === '图片异常') {
      data.brand_logo = this.eliminateImg(data.images[0].url);
    } else {
      const img = await this.upload(data.images[0].originFileObj, 'goods');
      data.brand_logo = img.sub_path;
    }
    delete data.images;
    return this.http.post('/Goods/brandSave', data);
  }

  static delete(id) {
    return this.http.post('/Goods/delBrand', { id });
  }
}